webpackJsonp([1],{

/***/ 1192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MessagesInbox__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Devices__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DeviceCommands__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Contacts__ = __webpack_require__(570);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Default',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */]
  }, {
    // path: '/MessagesInbox/:id',
    path: '/MessagesInbox',
    name: 'MessagesInbox',
    component: __WEBPACK_IMPORTED_MODULE_5__components_MessagesInbox__["a" /* default */]
    // ,      
    // props: { default: true, sidebar: false }
  },, {
    path: '/devices',
    name: 'Devices',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Devices__["a" /* default */]
  }, {
    path: '/Contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Contacts__["a" /* default */]
  }, {
    path: '/devicecommands',
    name: 'DeviceCommands',
    component: __WEBPACK_IMPORTED_MODULE_7__components_DeviceCommands__["a" /* default */]
  }]
}));

/***/ }),

/***/ 522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lodash__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;




var unsync = Object(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

//import components globaly




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_lodash___default.a, __WEBPACK_IMPORTED_MODULE_10_lodash___default.a);


// You need a specific loader for CSS files like https://github.com/webpack/css-loader
// If you would like custom styling of the toastr the css file can be replaced

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-bottom-left',
  defaultType: 'info',
  defaultTimeout: 5000
});

/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('currency', function (value) {
  if (value) {
    if (value < 0) {
      return '-$' + Math.abs(parseFloat(value)).toFixed(2);
    } else return '$' + parseFloat(value).toFixed(2);
  } else {
    return "$0";
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('toUpperCase', function (value) {
  return value.toUpperCase();
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatDate', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(value).calendar(); //format('LLL')
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatUnixDate', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)); //* 1000;
    // return moment(res).calendar();//format('LLL')
    return __WEBPACK_IMPORTED_MODULE_9_moment___default.a.unix(res).format('ddd, MMM Do, YYYY h:mm:ss A');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatEpochDateOnly', function (value) {
  if (value) {
    var res = parseInt(value); //* 1000;
    // return moment(res).calendar();//format('LLL')
    return __WEBPACK_IMPORTED_MODULE_9_moment___default.a.unix(res).format('ddd, MMM Do, YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatUnixDateOnly', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)); //* 1000;
    // return moment(res).calendar();//format('LLL')
    return __WEBPACK_IMPORTED_MODULE_9_moment___default.a.unix(res).format('ddd, MMM Do, YYYY');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatUnixTimeOnly', function (value) {
  if (value) {
    var res = parseInt(value.substring(0, 10)); //* 1000;
    // return moment(res).calendar();//format('LLL')
    return __WEBPACK_IMPORTED_MODULE_9_moment___default.a.unix(res).format('h:mm A');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('resolveContact', function (value) {
  if (value) {
    var user = __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].getters.contacts;
    if (user && user[value]) {
      return user[value].displayname + ' (' + value + ')';
    }
    return value;
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#vue-app',
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  // computed: {
  //   userState() {
  //     return this.$store.state.user
  //   }
  // },
  computed: Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['fcmToken']),
  // methods: mapActions(['setLocation', 'updateDealLocations', 'setSellerByReferenceName','setUser']),
  created: function created() {
    var _this = this;

    //The state here is post mutation. 
    __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].subscribe(function (action, state) {

      if (action.type === "setToastMessage" && state.toastmessage) {
        var toastMessage = state.toastmessage;
        _this.$toastr(toastMessage.type, toastMessage.message, toastMessage.title);
      }
    });

    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(Object({"apiKey":"AIzaSyA_UEY3u85oCbRlRXCzE-asxxfxpJ7xmOw","authDomain":"fibi-messaging.firebaseapp.com","databaseURL":"https://fibi-messaging.firebaseio.com","projectId":"fibi-messaging","storageBucket":"fibi-messaging.appspot.com","messagingSenderId":"399127790099"}));
    __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        console.log("User signed in");
        var mapUser = {
          uid: user.uid, // << Just the bits we need
          id: user.uid,
          email: user.email || "",
          displayName: user.displayName || "",
          name: user.displayName || "",
          // token: user.credential.accessToken || "",
          photo: user.photoURL
        };
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].commit('setUser', mapUser);
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setDevices');
        if (!_this.fcmToken) {
          setupmessaging();
        }

        // store.dispatch('monitorMessagesInbox')
        // store.dispatch('monitorContacts')
      } else {
        // No user is signed in.
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].commit('setToastMessage', { type: 'info', message: 'Login at any time.', title: 'Currently logged Out' });
      }
    });

    var messaging = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.messaging();
    setupmessaging();
    function setupmessaging() {
      messaging.requestPermission().then(function () {
        return messaging.getToken();
      }).then(function (token) {
        console.log('dispatching device token');
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setfcmToken', token);
      }).catch(function (err) {
        console.log('Unable to get permission to notify sending false token.', err);
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setfcmToken', "ToKEN_UNSUPPORTED");
      });
    }

    // [START refresh_token]
    // Callback fired if Instance ID token is updated.
    messaging.onTokenRefresh(function () {
      messaging.getToken().then(function (refreshedToken) {
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setfcmToken', refreshedToken);
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].dispatch('setfcmToken', "ToKEN_REFRESH_ERROR");
      });
    });

    // [END refresh_token]
    messaging.onMessage(function (payload) {
      _this.$toastr("info", payload.notification.body, payload.notification.title);
    });
  }
});

// During app/Vue teardown (e.g., you only use Vue.js in a portion of your app and you 
// navigate away from that portion and want to release/destroy Vue components/resources)
// unsync() // Unsyncs store from router

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd20d318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd20d318_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 527:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logout", "unRegister"]), {
    openSidebar: function openSidebar() {
      document.getElementById("mySidebar").style.display = "block";
    },
    closeSidebar: function closeSidebar() {
      var sb = document.getElementById("mySidebar");
      if (sb) {
        sb.style.display = "none";
      }
    }

  }),
  data: function data() {
    return {
      msg: ""
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["user", "contacts", "devices", "messagesinbox", "selecteddevice"]),
  created: function created() {
    // console.log(this.$store);
    // var sellerName = window.location.hostname.split(".")[0];
    // this.setSeller(sellerName);

  }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"w3-sidebar w3-bar-block w3-card",staticStyle:{"display":"none"},attrs:{"id":"mySidebar"}},[_c('div',{staticClass:"w3-container w3-theme-d2"},[_c('span',{staticClass:"w3-button w3-display-topright w3-large",on:{"click":function($event){_vm.closeSidebar()}}},[_vm._v("X")]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.user)?_c('div',{staticClass:"w3-padding w3-center"},[_vm._v("\n        "+_vm._s(_vm.user.displayName)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.closeSidebar()}}},[_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" "),(!_vm.user)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/login"}},[_vm._v("Login")]):_vm._e(),_vm._v(" "),(_vm.user && _vm.devices)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/devices"}},[_vm._v("Devices ("+_vm._s(Object.keys(_vm.devices).length)+")")]):_vm._e(),_vm._v(" "),(_vm.user && _vm.selecteddevice)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/devicecommands"}},[_vm._v("Device Commands")]):_vm._e(),_vm._v(" "),(_vm.user && _vm.selecteddevice)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/MessagesInbox"}},[_vm._v("Messages")]):_vm._e(),_vm._v(" "),(_vm.user && _vm.selecteddevice)?_c('router-link',{staticClass:"w3-bar-item w3-button",attrs:{"to":"/Contacts"}},[_vm._v("Contacts")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.logout();_vm.$router.push('home')}}},[_vm._v("Logout")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"w3-bar-item w3-button",attrs:{"href":"#"},on:{"click":function($event){_vm.unRegister()}}},[_vm._v("Refresh")])],1)]),_vm._v(" "),_c('header',{staticClass:"w3-top w3-bar w3-theme",staticStyle:{"height":"60px"}},[_c('button',{staticClass:"w3-bar-item w3-button w3-xlarge w3-hover-theme",on:{"click":function($event){_vm.openSidebar()}}},[_vm._v("☰")]),_vm._v(" "),_c('h3',{staticClass:"w3-bar-item w3-display-topmiddle",on:{"click":function($event){_vm.$router.push('home')}}},[(!_vm.selecteddevice)?_c('span',[_vm._v("Messaging Service")]):_vm._e(),_vm._v(" "),(_vm.selecteddevice)?_c('span',[_vm._v(_vm._s(_vm.devices[_vm.selecteddevice].label || 'Messaging Service'))]):_vm._e()])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"60px"},on:{"click":function($event){_vm.closeSidebar()}}},[_c('router-view')],1),_vm._v(" "),_c('footer',{staticClass:"w3-container footer",on:{"click":function($event){_vm.closeSidebar()}}},[_vm._v("      \n    Built on the FIBI.Works platform. For details see "),_c('a',{attrs:{"target":"_blank","href":"https://fibi.works"}},[_vm._v("FIBI")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-padding w3-center"},[_c('img',{staticClass:"w3-circle",staticStyle:{"width":"60px"},attrs:{"src":"static/img/icons/favicon-16x16.png","alt":"logo"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0c94cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(546);
function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e0c94cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(29);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Home",
  methods: {},
  data: function data() {
    return {
      msg: ""
    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  // computed: mapGetters(["seller"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-container home"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efe9255e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efe9255e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(29);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "About",
  data: function data() {
    return {
      msg: ""
    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  // computed: mapGetters(["seller"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-container about"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716aeb2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(554);
function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716aeb2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      msg: "Sign in with your provider."
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["logUserInGoogle", "logUserInFacebook"])),
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  // computed: mapGetters(["seller"]),
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["user"]),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {}
});

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container loginLayout"},[(!_vm.user)?_c('div',[_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"loginBtn loginBtn--google",on:{"click":function($event){_vm.logUserInGoogle()}}},[_vm._v("\n          Login with Google\n        ")])]):_c('div',[_c('span',[_vm._v("Welcome "+_vm._s(_vm.user.displayName)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessagesInbox_vue__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e8afde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessagesInbox_vue__ = __webpack_require__(561);
function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessagesInbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e8afde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessagesInbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 556:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MessagesInbox",
  filters: {
    countmessages: function countmessages(messagesdaygrouping) {
      var messagecount = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(messagesdaygrouping).forEach(function (epochkey) {
        var epoch = messagesdaygrouping[epochkey];
        messagecount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(epoch.messages).length;
      });
      return messagecount;
    }
  },
  data: function data() {
    return {
      selectedphonenumber: null,
      newnumber: null,
      newunknown: null,
      msg: "Welcome to the MessagesInbox page",
      message: null
    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    clear: function clear() {
      this.selectedphonenumber = null;
      this.newnumber = null;
      this.newunknown = null;
      this.message = null;
    },
    createSendSMS: function createSendSMS(number) {
      this.sendSMS({ too: number, message: this.message });
      this.message = null;
    },
    clearAndSyncMessages: function clearAndSyncMessages() {
      this.sendDeviceCommand({ type: 'RefreshInboxes' });
      this.clear();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["sendSMS", "sendDeviceCommand", "setSelectedNumber"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["user", "messagesinbox", "selecteddevice"])),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {
    this.selectedphonenumber = null;
    this.newnumber = null;
    this.newunknown = null;
    this.message = null;
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.selecteddevice)?_c('div',{staticClass:"w3-container messageinbox"},[(!_vm.selectedphonenumber && !_vm.newunknown)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$router.push('devices')}}},[_vm._v("««")]):_vm._e(),_vm._v(" "),(_vm.newunknown)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.clear()}}},[_vm._v("««")]):_vm._e(),_vm._v(" "),(_vm.selectedphonenumber)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.clear()}}},[_vm._v("«« "+_vm._s(_vm._f("resolveContact")(_vm.selectedphonenumber)))]):_vm._e(),_vm._v(" "),(_vm.user && _vm.selecteddevice)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.clearAndSyncMessages()}}},[_vm._v("Sync Inboxes")]):_vm._e(),_vm._v(" "),_c('p',[(!_vm.newunknown && !_vm.selectedphonenumber)?_c('button',{staticClass:"w3-button w3-block w3-border w3-round-xxlarge",on:{"click":function($event){_vm.newunknown=true}}},[_vm._v("Create New")]):_vm._e()]),_vm._v(" "),(_vm.messagesinbox && !_vm.selectedphonenumber && !_vm.newunknown)?[_c('ul',{staticClass:"w3-ul w3-panel w3-border w3-round-large"},_vm._l((_vm.messagesinbox),function(messages,keyPhone){return _c('li',{key:keyPhone},[_c('button',{staticClass:"w3-button w3-block w3-border w3-round-xxlarge",on:{"click":function($event){_vm.selectedphonenumber = keyPhone}}},[_vm._v("\n          "+_vm._s(_vm._f("resolveContact")(keyPhone))+" ("+_vm._s(_vm._f("countmessages")(messages))+")")])])}))]:_vm._e(),_vm._v(" "),(_vm.selectedphonenumber && !_vm.newunknown)?[_c('div',{staticClass:"w3-ul w3-panel w3-border w3-round-large"},[_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"3"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]),_vm._v(" "),_c('p',[(_vm.message)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.createSendSMS(_vm.selectedphonenumber);}}},[_vm._v("Send")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.messagesinbox[_vm.selectedphonenumber]),function(groupeddates,keydate){return _c('div',{key:keydate},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm._f("formatEpochDateOnly")(groupeddates.messagegroupingdate)))])]),_vm._v(" "),_vm._l((groupeddates.messages),function(messageDetails,keymessagedate){return _c('div',{key:keymessagedate},[_c('div',{class:{'w3-display-container:true, triangle-isosceles right': messageDetails.type===2,'triangle-isosceles left': messageDetails.type===1 }},[_c('div',[_vm._v(_vm._s(_vm._f("formatUnixTimeOnly")(messageDetails.date)))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(messageDetails.message))]),_vm._v(" "),_c('span',{staticClass:"w3-display-bottomright delete"},[_c('h1',{on:{"click":function($event){_vm.sendDeviceCommand({type:'deletemessage',info:messageDetails})}}},[_vm._v("×")])])])])})],2)})],2)]:_vm._e(),_vm._v(" "),(_vm.newunknown && !_vm.selectedphonenumber)?[_c('div',{staticClass:"w3-ul w3-panel w3-border w3-round-large smsnew"},[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newnumber),expression:"newnumber"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel","placeholder":"Enter Number"},domProps:{"value":(_vm.newnumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newnumber=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"15"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]),_vm._v(" "),(_vm.message && _vm.newnumber)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.createSendSMS(_vm.newnumber);}}},[_vm._v("Send")]):_vm._e()])]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_580713a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_580713a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(29);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Devices",
  data: function data() {
    return {
      editdevice: null,
      msg: "Welcome to the Devices page"

    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    setSelectedSim: function setSelectedSim(selectedsimKey) {
      var sims = this.devices[this.editdevice._uuid].sims;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sims).forEach(function (simkey) {
        sims[simkey].default = simkey === selectedsimKey;
      });
      this.editdevice.sims[selectedsimKey].default = true;
    },
    editThisdevice: function editThisdevice(device) {
      this.editdevice = device;
    },
    clear: function clear() {
      this.editdevice = null;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["setSelectedDevice", "saveDeviceInfo"])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["user", "devices", "selecteddevice"])),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {
    this.editdevice = null;
  }
});

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"w3-container devicecontainer"},[(_vm.editdevice)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.clear()}}},[_vm._v("««")]):_vm._e(),_vm._v(" "),(_vm.devices && !_vm.editdevice)?_vm._l((_vm.devices),function(device,deviceKey){return _c('div',{key:deviceKey},[_c('div',{staticClass:"w3-round-large w3-block w3-border w3-round-xxlarge w3-display-container",staticStyle:{"height":"150px"}},[_c('span',{staticClass:"w3-display-left",on:{"click":function($event){_vm.editThisdevice(device)}}},[_c('h2',{staticClass:"w3-padding w3-display-left"},[_c('font',{attrs:{"color":"green"}},[_c('i',{staticClass:"fa fa-pencil"})])],1)]),_vm._v(" "),_c('h4',{staticClass:"w3-padding w3-display-topmiddle",on:{"click":function($event){_vm.setSelectedDevice(deviceKey)}}},[(_vm.selecteddevice===deviceKey)?_c('font',{attrs:{"color":"green"}},[_vm._v(_vm._s(device._deviceType)+"-"+_vm._s(device.label))]):_vm._e(),_vm._v(" "),(_vm.selecteddevice!==deviceKey)?_c('font',{attrs:{"color":"gray"}},[_vm._v(_vm._s(device._deviceType)+"-"+_vm._s(device.label))]):_vm._e()],1),_vm._v(" "),_vm._l((device.sims),function(sim,simKey){return _c('div',{key:simKey,staticClass:"w3-padding w3-display-bottommiddle"},[(sim.default)?_c('span',[_c('div',[_vm._v("SIM Number/label:"+_vm._s(sim.phoneNumber))]),_vm._v(" "),_c('div',[_vm._v("Carrier:"+_vm._s(sim.carrierName))])]):_vm._e()])}),_vm._v(" "),_c('span',{staticClass:"w3-display-right",on:{"click":function($event){_vm.setSelectedDevice(deviceKey);_vm.$router.push('MessagesInbox')}}},[_c('h2',{staticClass:"w3-padding w3-display-right"},[_c('font',{attrs:{"color":"green"}},[_c('i',{staticClass:"fa fa-envelope-o"})])],1)])],2),_vm._v(" "),_c('br')])}):_vm._e(),_vm._v(" "),(_vm.editdevice)?[_c('div',{staticClass:"w3-ul w3-panel w3-border w3-round-large devicecontainer"},[_c('p'),_c('div',{staticClass:"w3-row w3-section"},[_c('div',{staticClass:"w3-rest"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editdevice.label),expression:"editdevice.label"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"type":"tel","placeholder":_vm.editdevice._deviceType + ' Friendly label'},domProps:{"value":(_vm.editdevice.label)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editdevice, "label", $event.target.value)}}})])]),_vm._v(" "),_vm._l((_vm.editdevice.sims),function(sim,simKey){return _c('div',{key:simKey,staticClass:"w3-button w3-block w3-border w3-round-xxlarge w3-display-container"},[_c('span',[_c('div',{staticClass:"w3-row-padding"},[_c('div',{staticClass:"w3-half"},[_c('label',[_vm._v("SIM ID")]),_vm._v("\n                      "+_vm._s(sim.deviceId)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"w3-half"},[_c('label',[_vm._v("Carrier")]),_vm._v("\n                      "+_vm._s(sim.carrierName)+"\n                    ")])]),_vm._v(" "),_c('span',[_c('div',{staticClass:"w3-row w3-section"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"w3-rest"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(sim.phoneNumber),expression:"sim.phoneNumber"}],staticClass:"w3-input w3-border",attrs:{"name":sim.deviceId,"type":"text","placeholder":"SIM Number"},domProps:{"value":(sim.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(sim, "phoneNumber", $event.target.value)}}})])])]),_vm._v(" "),_c('span',{staticClass:"w3-display-topright"},[_c('h2',{staticClass:"w3-padding",on:{"click":function($event){_vm.setSelectedSim(simKey)}}},[(sim.default)?_c('font',{attrs:{"color":"green"}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(!sim.default)?_c('font',{attrs:{"color":"gray"}},[_c('i',{staticClass:"fa fa-check"})]):_vm._e()],1)])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.saveDeviceInfo(_vm.devices);}}},[_vm._v("Save")])],2)]:_vm._e()],2):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-col",staticStyle:{"width":"50px"}},[_c('i',{staticClass:"w3-xlarge fa fa-phone"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceCommands_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e5532c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceCommands_vue__ = __webpack_require__(569);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceCommands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e5532c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceCommands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 567:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DeviceCommands",
  data: function data() {
    return {
      msg: "Welcome to the Device Commands Page"
    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["sendDeviceCommand"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["user", "devices", "selecteddevice"]))
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"w3-container devicecommands"},[_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$router.push('home')}}},[_vm._v("««")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.devices && _vm.selecteddevice)?[_c('p',[_c('button',{staticClass:"w3-button w3-block w3-border w3-round-xxlarge",on:{"click":function($event){_vm.sendDeviceCommand({type:'RefreshInboxes'})}}},[_vm._v("Sync Inboxes")])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"w3-button w3-block w3-border w3-round-xxlarge",on:{"click":function($event){_vm.sendDeviceCommand({type:'GetContacts'})}}},[_vm._v("Sync Contacts")])])]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ae0c782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(40)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ae0c782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 571:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(29);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Contacts",
  data: function data() {
    return {
      msg: "Welcome to the Contacts page",
      selectedcontact: null,
      selectedphone: null,
      message: null
    };
  },
  beforeCreated: function beforeCreated() {},

  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createMessage: function createMessage(contactdetails, phone) {
      this.selectedcontact = contactdetails;
      this.selectedphone = phone;
      this.message = null;
    },
    clearSelected: function clearSelected() {
      this.selectedcontact = null;
      this.selectedphone = null;
      this.message = null;
    },
    createSendSMS: function createSendSMS() {
      this.sendSMS({ too: this.selectedphone, message: this.message });
      this.clearSelected();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["sendSMS"])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["user", "contacts"])),
  beforeDestroy: function beforeDestroy() {},
  destroy: function destroy() {
    this.clearSelected();
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"w3-container contacts"},[(!_vm.selectedcontact)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.$router.push('menu')}}},[_vm._v("««")]):_vm._e(),_vm._v(" "),(_vm.selectedcontact)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.clearSelected()}}},[_vm._v("«« "+_vm._s(_vm.selectedcontact.displayname)+" "+_vm._s(_vm.selectedphone)+" ")]):_vm._e(),_vm._v(" "),(_vm.contacts && !_vm.selectedcontact)?[_c('ul',{staticClass:"w3-ul w3-panel w3-border w3-round-large"},_vm._l((_vm.contacts),function(contactdetails,phone){return _c('li',{key:phone,staticClass:"container"},[_c('button',{staticClass:"w3-button w3-block w3-border w3-round-xxlarge",on:{"click":function($event){_vm.createMessage(contactdetails, phone)}}},[_c('div',[_vm._v(_vm._s(contactdetails.displayname)+" Mobile:"+_vm._s(phone)+" ")])])])}))]:_vm._e(),_vm._v(" "),(_vm.selectedcontact)?[_c('div',{staticClass:"w3-ul w3-panel w3-border w3-round-large sms"},[_c('p',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"w3-input w3-border",staticStyle:{"resize":"none"},attrs:{"rows":"15"},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})]),_vm._v(" "),(_vm.message)?_c('button',{staticClass:"w3-button w3-border w3-round-xxlarge",on:{"click":function($event){_vm.createSendSMS();}}},[_vm._v("Send")]):_vm._e()])]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_async__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(197);



var _this3 = this;








// import Rx from 'rxjs/Rx'


__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

// import { Observable } from 'rxjs/Observable';

var logger = __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()({
    collapsed: false, // auto-expand logged mutations
    filter: function filter(mutation, stateBefore, stateAfter) {
        // returns `true` if a mutation should be logged
        // `mutation` is a `{ type, payload }`
        return mutation.type !== "aBlacklistedMutation";
    },
    transformer: function transformer(state) {
        // transform the state before logging it.
        // for example return only a specific sub-tree
        return state.subTree;
    },
    mutationTransformer: function mutationTransformer(mutation) {
        // mutations are logged in the format of `{ type, payload }`
        // we can format it any way we want.
        return mutation.type;
    },

    logger: console // implementation of the `console` API, default `console`
});

var state = {
    messagesinbox: null,
    contacts: null,
    devices: null,
    selecteddevice: null,
    user: null,
    toastmessage: null,
    fcmToken: null
};

var getters = {
    messagesinbox: function messagesinbox(state) {
        return state.messagesinbox;
    },
    devices: function devices(state) {
        return state.devices;
    },
    selecteddevice: function selecteddevice(state) {
        return state.selecteddevice;
    },
    user: function user(state) {
        return state.user;
    },
    contacts: function contacts(state) {
        return state.contacts;
    },
    fcmToken: function fcmToken(state) {
        return state.fcmToken;
    }
};

var mutations = {
    //reducers   
    setUser: function setUser(state, user) {
        state.user = user;
    },
    setContacts: function setContacts(state, contacts) {
        state.contacts = contacts;
    },
    setDevices: function setDevices(state, devices) {
        state.devices = devices;
    },
    setSelectedDevice: function setSelectedDevice(state, selecteddevice) {
        state.selecteddevice = selecteddevice;
    },
    setToastMessage: function setToastMessage(state, toastmessage) {
        state.toastmessage = toastmessage;
    },
    setMessagesInbox: function setMessagesInbox(state, messagesinbox) {
        state.messagesinbox = messagesinbox;
    },
    logout: function logout(state) {
        state.user = null;
        state.messagesinbox = null;
        state.toastmessage = null;
        state.devices = null, state.selecteddevice = null, state.contacts = null, state.fcmToken = null;
    },
    setfcmToken: function setfcmToken(state, fcmToken) {
        state.fcmToken = fcmToken;
    }
};

var actions = {
    setSelectedDevice: function setSelectedDevice(context, selecteddevice) {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var currentSelectedDevice, unix;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            currentSelectedDevice = context.state.selecteddevice;


                            context.commit('setSelectedDevice', selecteddevice);
                            context.dispatch('monitorMessagesInbox', selecteddevice);
                            context.dispatch('monitorContacts', selecteddevice);
                            unix = __WEBPACK_IMPORTED_MODULE_7_moment___default.a.utc().unix();

                            if (!context.state.fcmToken) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + context.state.user.uid + '/fcmTokens/pwa/' + currentSelectedDevice + '/' + context.state.fcmToken).set(null).then(function () {
                                return "token cleared";
                            });

                        case 8:
                            _context.next = 10;
                            return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + context.state.user.uid + '/fcmTokens/pwa/' + selecteddevice + '/' + context.state.fcmToken).set(unix).then(function () {
                                console.log("token sent to server");
                                return "token sent to server";
                            }).catch(function (ex) {
                                console.log(ex);
                            });

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    monitorMessagesInbox: function monitorMessagesInbox(context, device) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/' + device + '/messagesobject').on('value', function (snapshot) {
                                var messages = snapshot.val();
                                context.commit('setMessagesInbox', messages);
                            });

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },
    sendDeviceCommand: function sendDeviceCommand(_ref, request) {
        var commit = _ref.commit,
            state = _ref.state;


        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/' + state.selecteddevice + '/devicecommands').push(request).then(function () {
            commit('setToastMessage', { type: 'info', message: 'Sending Command ' + request.type, title: 'Commands' });
        }).catch(function (ex) {});
    },
    sendSMS: function sendSMS(_ref2, messagedetails) {
        var commit = _ref2.commit,
            state = _ref2.state;

        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/' + state.selecteddevice + '/sendmessages/sms').push({
            too: messagedetails.too,
            message: messagedetails.message
        }).then(function () {
            commit('setToastMessage', { type: 'info', message: 'Sending', title: 'SMS' });
        }).catch(function (ex) {});
    },
    setDevices: function setDevices(context) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/devices/').on('value', function (snapshot) {
            var devices = snapshot.val();
            context.commit('setDevices', devices);
        });
    },
    saveDeviceInfo: function saveDeviceInfo(context, devices) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/devices/').update(devices);

        context.commit('setDevices', devices);
    },
    monitorContacts: function monitorContacts(context, device) {
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid + '/' + device + '/contacts').on('value', function (snapshot) {
            var contacts = snapshot.val();
            context.commit('setContacts', contacts);
        });
    },


    // logUserInFacebook({ commit, state }) {
    //     var provider = new firebase.auth.FacebookAuthProvider();
    //     provider.addScope("email");
    //     firebase
    //         .auth()
    //         .signInWithPopup(provider)
    //         .then(result => {                
    //             commit('setToastMessage', { type: 'info', message: `${result.user.displayName} you are logged in with your Facebook account`, title: 'Facebook Login' })
    //         });
    // },

    logUserInGoogle: function logUserInGoogle(_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signInWithPopup(provider).then(function (result) {
            commit('setToastMessage', { type: 'info', message: result.user.displayName + ' you are logged in with your Google account', title: 'Google Login' });
        });
    },


    logout: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
            var commit = _ref5.commit,
                state = _ref5.state;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.database().ref('users/' + state.user.uid + '/fcmTokens/pwa/' + state.selecteddevice + '/' + state.fcmToken).set(null).then(function () {
                                console.log("token sent to server");
                                return "token sent to server";
                            }).catch(function (ex) {
                                console.log(ex);
                            });

                        case 2:
                            _context3.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut().then(function () {
                                commit('logout');
                            });

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function logout(_x) {
            return _ref4.apply(this, arguments);
        };
    }(),

    unRegister: function unRegister(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state;

        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                registrations.forEach(function (registration) {
                    registration.unregister();
                    console.log("Unregistered.");
                }, this);
            }).then(function () {
                window.location.reload(true); //reload after token cleared.
            });
        } else {
            window.location.reload(true); //reload after token cleared.
        }
    },

    setfcmToken: function setfcmToken(context, fcmToken) {
        context.commit('setfcmToken', fcmToken);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
    // strict: true,    
    plugins: [__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()()],
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}));

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 303,
	"./af.js": 303,
	"./ar": 304,
	"./ar-dz": 305,
	"./ar-dz.js": 305,
	"./ar-kw": 306,
	"./ar-kw.js": 306,
	"./ar-ly": 307,
	"./ar-ly.js": 307,
	"./ar-ma": 308,
	"./ar-ma.js": 308,
	"./ar-sa": 309,
	"./ar-sa.js": 309,
	"./ar-tn": 310,
	"./ar-tn.js": 310,
	"./ar.js": 304,
	"./az": 311,
	"./az.js": 311,
	"./be": 312,
	"./be.js": 312,
	"./bg": 313,
	"./bg.js": 313,
	"./bm": 314,
	"./bm.js": 314,
	"./bn": 315,
	"./bn.js": 315,
	"./bo": 316,
	"./bo.js": 316,
	"./br": 317,
	"./br.js": 317,
	"./bs": 318,
	"./bs.js": 318,
	"./ca": 319,
	"./ca.js": 319,
	"./cs": 320,
	"./cs.js": 320,
	"./cv": 321,
	"./cv.js": 321,
	"./cy": 322,
	"./cy.js": 322,
	"./da": 323,
	"./da.js": 323,
	"./de": 324,
	"./de-at": 325,
	"./de-at.js": 325,
	"./de-ch": 326,
	"./de-ch.js": 326,
	"./de.js": 324,
	"./dv": 327,
	"./dv.js": 327,
	"./el": 328,
	"./el.js": 328,
	"./en-au": 329,
	"./en-au.js": 329,
	"./en-ca": 330,
	"./en-ca.js": 330,
	"./en-gb": 331,
	"./en-gb.js": 331,
	"./en-ie": 332,
	"./en-ie.js": 332,
	"./en-nz": 333,
	"./en-nz.js": 333,
	"./eo": 334,
	"./eo.js": 334,
	"./es": 335,
	"./es-do": 336,
	"./es-do.js": 336,
	"./es-us": 337,
	"./es-us.js": 337,
	"./es.js": 335,
	"./et": 338,
	"./et.js": 338,
	"./eu": 339,
	"./eu.js": 339,
	"./fa": 340,
	"./fa.js": 340,
	"./fi": 341,
	"./fi.js": 341,
	"./fo": 342,
	"./fo.js": 342,
	"./fr": 343,
	"./fr-ca": 344,
	"./fr-ca.js": 344,
	"./fr-ch": 345,
	"./fr-ch.js": 345,
	"./fr.js": 343,
	"./fy": 346,
	"./fy.js": 346,
	"./gd": 347,
	"./gd.js": 347,
	"./gl": 348,
	"./gl.js": 348,
	"./gom-latn": 349,
	"./gom-latn.js": 349,
	"./gu": 350,
	"./gu.js": 350,
	"./he": 351,
	"./he.js": 351,
	"./hi": 352,
	"./hi.js": 352,
	"./hr": 353,
	"./hr.js": 353,
	"./hu": 354,
	"./hu.js": 354,
	"./hy-am": 355,
	"./hy-am.js": 355,
	"./id": 356,
	"./id.js": 356,
	"./is": 357,
	"./is.js": 357,
	"./it": 358,
	"./it.js": 358,
	"./ja": 359,
	"./ja.js": 359,
	"./jv": 360,
	"./jv.js": 360,
	"./ka": 361,
	"./ka.js": 361,
	"./kk": 362,
	"./kk.js": 362,
	"./km": 363,
	"./km.js": 363,
	"./kn": 364,
	"./kn.js": 364,
	"./ko": 365,
	"./ko.js": 365,
	"./ky": 366,
	"./ky.js": 366,
	"./lb": 367,
	"./lb.js": 367,
	"./lo": 368,
	"./lo.js": 368,
	"./lt": 369,
	"./lt.js": 369,
	"./lv": 370,
	"./lv.js": 370,
	"./me": 371,
	"./me.js": 371,
	"./mi": 372,
	"./mi.js": 372,
	"./mk": 373,
	"./mk.js": 373,
	"./ml": 374,
	"./ml.js": 374,
	"./mr": 375,
	"./mr.js": 375,
	"./ms": 376,
	"./ms-my": 377,
	"./ms-my.js": 377,
	"./ms.js": 376,
	"./my": 378,
	"./my.js": 378,
	"./nb": 379,
	"./nb.js": 379,
	"./ne": 380,
	"./ne.js": 380,
	"./nl": 381,
	"./nl-be": 382,
	"./nl-be.js": 382,
	"./nl.js": 381,
	"./nn": 383,
	"./nn.js": 383,
	"./pa-in": 384,
	"./pa-in.js": 384,
	"./pl": 385,
	"./pl.js": 385,
	"./pt": 386,
	"./pt-br": 387,
	"./pt-br.js": 387,
	"./pt.js": 386,
	"./ro": 388,
	"./ro.js": 388,
	"./ru": 389,
	"./ru.js": 389,
	"./sd": 390,
	"./sd.js": 390,
	"./se": 391,
	"./se.js": 391,
	"./si": 392,
	"./si.js": 392,
	"./sk": 393,
	"./sk.js": 393,
	"./sl": 394,
	"./sl.js": 394,
	"./sq": 395,
	"./sq.js": 395,
	"./sr": 396,
	"./sr-cyrl": 397,
	"./sr-cyrl.js": 397,
	"./sr.js": 396,
	"./ss": 398,
	"./ss.js": 398,
	"./sv": 399,
	"./sv.js": 399,
	"./sw": 400,
	"./sw.js": 400,
	"./ta": 401,
	"./ta.js": 401,
	"./te": 402,
	"./te.js": 402,
	"./tet": 403,
	"./tet.js": 403,
	"./th": 404,
	"./th.js": 404,
	"./tl-ph": 405,
	"./tl-ph.js": 405,
	"./tlh": 406,
	"./tlh.js": 406,
	"./tr": 407,
	"./tr.js": 407,
	"./tzl": 408,
	"./tzl.js": 408,
	"./tzm": 409,
	"./tzm-latn": 410,
	"./tzm-latn.js": 410,
	"./tzm.js": 409,
	"./uk": 411,
	"./uk.js": 411,
	"./ur": 412,
	"./ur.js": 412,
	"./uz": 413,
	"./uz-latn": 414,
	"./uz-latn.js": 414,
	"./uz.js": 413,
	"./vi": 415,
	"./vi.js": 415,
	"./x-pseudo": 416,
	"./x-pseudo.js": 416,
	"./yo": 417,
	"./yo.js": 417,
	"./zh-cn": 418,
	"./zh-cn.js": 418,
	"./zh-hk": 419,
	"./zh-hk.js": 419,
	"./zh-tw": 420,
	"./zh-tw.js": 420
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 885;

/***/ }),

/***/ 888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_config__ = __webpack_require__(889);
/* unused harmony reexport namespace */


/***/ }),

/***/ 889:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(85);





// import { http } from 'vue-resource';

var AppConfig = function () {
    function AppConfig() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppConfig);

        this.config = null;
        this.env = null;
    }

    /**
     * Use to get the data found in the second file (config file)
     */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppConfig, [{
        key: 'getConfig',
        value: function getConfig(key) {
            return this.config[key];
        }

        /**
         * Use to get the data found in the first file (env file)
         */

    }, {
        key: 'getEnv',
        value: function getEnv(key) {
            return this.env[key];
        }

        /**
         * This method:
         *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
         *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
         */

    }, {
        key: 'load',
        value: function load() {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                // Vue.http.get('test.html').then((res)=>{
                //     console.log(res);
                // })

                // Vue.http.get('/assets/env.json').map( res => res.json() ).catch((error) => {
                //     console.log('Configuration file "env.json" could not be read');
                //     resolve(true);
                //     return Observable.throw(error.json().error || 'Server error');
                // }).subscribe( (envResponse) => {
                //     env = envResponse;
                //     let req = null;

                //     switch (envResponse.env) {
                //         case 'production': {
                //             req = request.get('/assets/config.' + envResponse.env + '.json');
                //         } break;

                //         case 'development': {
                //             req = request.get('/assets/config.' + envResponse.env + '.json');
                //         } break;

                //         case 'default': {
                //             console.error('Environment file is not set or invalid');
                //             resolve(true);
                //         } break;
                //     }

                //     if (req) {
                //         req
                //             .map( (res) => res.json() )
                //             .catch((error) => {
                //                 console.error('Error reading ' + envResponse.env + ' configuration file');
                //                 resolve(error);
                //                 return Observable.throw(error.json().error || 'Server error');
                //             })
                //             .subscribe((responseData) => {
                //                 this.config = responseData;
                //                 resolve(true);
                //             });
                //     } else {
                //         console.error('Env config file "env.json" is not valid');
                //         resolve(true);
                //     }
                // });

            });
        }
    }]);

    return AppConfig;
}();

/***/ })

},[522]);


// WEBPACK FOOTER //
// static/js/app.3c0fc5d3006e93657003.js